import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { PackageIcon, FileTextIcon, CheckIcon, CheckCircleIcon, ArrowRightIcon, GiftIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function OfferSection() {
  return <SectionWrapper className="bg-cyber-dark/30 border-t border-cyber-purple/20" data-id="element-386">
      <div className="max-w-3xl mx-auto" data-id="element-387">
        <div className="text-center mb-10" data-id="element-388">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-cyber-purple/10 border border-cyber-purple mb-4 shadow-neon-purple" data-id="element-389">
            <PackageIcon className="w-7 h-7 text-cyber-purple" data-id="element-390" />
          </div>
          <h2 className="text-2xl md:text-4xl text-white mb-3 font-mono" data-id="element-391">
            SISTEMA DE TRANSFORMACIÓN{' '}
            <span className="text-cyber-purple text-shadow-purple" data-id="element-392">
              SOCIAL HACKER
            </span>
          </h2>
          <p className="text-gray-400" data-id="element-393">
            Hoy no solo te llevas un libro, te llevas el protocolo completo.
          </p>
        </div>

        <div className="bg-cyber-black border border-cyber-purple/50 rounded-xl overflow-hidden relative" data-id="element-394">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyber-purple to-transparent opacity-50" data-id="element-395"></div>

          <div className="bg-cyber-dark/80 p-5 md:p-7" data-id="element-396">
            <div className="flex items-start gap-4" data-id="element-397">
              <div className="bg-cyber-purple/20 p-2.5 rounded-lg border border-cyber-purple/30 shrink-0" data-id="element-398">
                <FileTextIcon className="w-5 h-5 text-cyber-purple" data-id="element-399" />
              </div>
              <div className="flex-1" data-id="element-400">
                <h3 className="text-lg text-white font-mono font-bold mb-1.5 flex flex-wrap items-center gap-2" data-id="element-401">
                  Ebook: Social Hacker v1.0
                  <span className="text-xs bg-cyber-purple/20 text-cyber-purple px-2 py-0.5 rounded border border-cyber-purple/30" data-id="element-402">
                    (60 Págs)
                  </span>
                </h3>
                <p className="text-gray-400 text-sm mb-3" data-id="element-403">
                  El mapa exacto de 30 días para reprogramar tu cerebro.
                </p>
                <ul className="space-y-1.5 font-mono text-sm mb-4" data-id="element-404">
                  <li className="flex items-center gap-2 text-gray-300" data-id="element-405">
                    <CheckIcon className="w-4 h-4 text-cyber-neon shrink-0" data-id="element-406" />
                    <span data-id="element-407">Protocolo de Micro-Exposición paso a paso</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-300" data-id="element-408">
                    <CheckIcon className="w-4 h-4 text-cyber-neon shrink-0" data-id="element-409" />
                    <span data-id="element-410">
                      Scripts de 3 segundos para iniciar conversaciones
                    </span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-300" data-id="element-411">
                    <CheckIcon className="w-4 h-4 text-cyber-neon shrink-0" data-id="element-412" />
                    <span data-id="element-413">Técnicas de hackeo del sistema nervioso</span>
                  </li>
                </ul>

                <div className="flex items-center gap-3 mb-4 pt-3 border-t border-gray-800" data-id="element-414">
                  <span className="text-gray-500 line-through text-sm" data-id="element-415">
                    $121
                  </span>
                  <span className="text-cyber-neon font-bold font-mono text-xl" data-id="element-416">
                    $9.99
                  </span>
                  <span className="text-cyber-neon/70 text-xs font-mono" data-id="element-417">
                    Ahorras $111.01
                  </span>
                </div>

                <NeonButton href={CHECKOUT_URL} size="md" fullWidth data-id="element-418">
                  DESCARGAR AHORA POR $9.99{' '}
                  <ArrowRightIcon className="w-4 h-4" data-id="element-419" />
                </NeonButton>
                <span className="flex items-center gap-1.5 text-[11px] font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-3 py-1.5 mt-2 shadow-[0_0_8px_rgba(57,255,20,0.1)]" data-id="element-420">
                  <GiftIcon className="w-3 h-3 text-cyber-neon animate-pulse" data-id="element-421" />
                  <span className="text-gray-300" data-id="element-422">
                    + 2 Bonos{' '}
                    <strong className="text-cyber-neon" data-id="element-423">GRATIS</strong>{' '}
                    incluidos <span className="text-gray-500" data-id="element-424">(valor $47)</span>
                  </span>
                </span>
                <div className="bg-cyber-dark/60 border border-cyber-neon/15 rounded-lg p-2.5 space-y-1.5 mt-1" data-id="element-425">
                  <div className="flex items-start gap-2" data-id="element-426">
                    <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-427" />
                    <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-428">
                      <span className="text-gray-300 font-bold" data-id="element-429">Bonus 1:</span>{' '}
                      Scripts de Supervivencia en Citas — qué decir para que
                      nunca haya silencios incómodos.
                      <span className="ml-1 text-gray-500 line-through" data-id="element-430">
                        $25
                      </span>
                      <span className="ml-1 text-cyber-neon font-bold" data-id="element-431">
                        GRATIS
                      </span>
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-432">
                    <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-433" />
                    <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-434">
                      <span className="text-gray-300 font-bold" data-id="element-435">Bonus 2:</span>{' '}
                      Templates de Texto Irresistibles — para que nunca más te
                      dejen en "visto" en WhatsApp.
                      <span className="ml-1 text-gray-500 line-through" data-id="element-436">
                        $22
                      </span>
                      <span className="ml-1 text-cyber-neon font-bold" data-id="element-437">
                        GRATIS
                      </span>
                    </p>
                  </div>
                  <div className="border-t border-cyber-neon/20 pt-1.5 mt-1" data-id="element-438">
                    <p className="text-[11px] font-mono text-cyber-neon font-bold text-center" data-id="element-439">
                      Te ahorras $47 USD en bonos de regalo
                    </p>
                  </div>
                </div>
                <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
                behavior: 'smooth'
              })} className="text-[11px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors mt-1" data-id="element-440">
                  Leer más
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}